<template>
  <path
    d="M8,1.5c3.6,0,6.5,2.9,6.5,6.5s-2.9,6.5-6.5,6.5S1.5,11.6,1.5,8S4.4,1.5,8,1.5z M4.2,2.9l5.1-1.2l5.1,1.2v5.7
	c0,1.9-1.1,3.6-2.8,4.5l-2.3,1.1L7,13c-1.7-0.8-2.8-2.5-2.8-4.4V2.9z"
  />
</template>
